$(document).ready(function () {
    bind_callback_form();
    bind_feedback_form();
    $('[data-toggle="popover"]').popover();
    show_notice_modal();
    bindFileUpload();
});

//function toggle 3PL block
function toggle3PL() {
    $('.pl-hidden').toggleClass('in');
    console.log('a');
}

//mobile menu toggle nav
function toggleMobileNav() {
    $('.mobile-panel').toggleClass('in');
}

//init track number
function init_track() {
    let track = new Track('track-form');
    track.bind();

    $('#track_submit').on('click', function () {
        $('#track-form').submit();
    });
}
function bind_callback_form() {
    let form = $('form[data-form="callback"]');

    form.on('beforeSubmit', function (e) {
        e.preventDefault();

        let event_target = $(this).data('event-target');
        if (event_target) {
            ym(73234981, 'reachGoal', event_target);
        }

        let url = $(this).attr('data-url');

        let data = new FormData(this);

        let callback = (result) => {
            if (result.status) {

                form.trigger('reset');
            }


            if ($('#cod-quick-registration').length > 0) {
                $('#cod-quick-registration').modal('hide');
            }

            let notice = new Notice(result.status, result.response);
            notice.showNotice();
        };

        let errorCallback = (xhr, status, error) => {
            console.error('AJAX Error:', error);
            let notice = new Notice(false, 'Произошла ошибка при отправке формы. Пожалуйста, попробуйте снова.');
            notice.showNotice();
        };

        // Создаем и отправляем AJAX-запрос
        let request = new Ajax({
            url: url,
            data: data,
            callback: callback,
            errorCallback: errorCallback
        });

        request.ajaxRequestDOM();

        return false;
    });
}
function bind_feedback_form() {

    let form = $('form[data-form="feedback"]');

    form.on('beforeSubmit', function (e) {
        e.preventDefault();
        var $form = $(this);

        let url = $(this).attr('data-url');
        //let data = $(this).serialize();
        let data = new FormData(this);
        let callback = (result) => {
            window.resFeed = result;
            if (result.status) {
                form.trigger('reset');
                $('#feedback.modal').modal('hide')
                swal("Сообщение отправлено", result.response, "success");
                return;
            }
            if (result.errors) {
                if (result.errors.order_number) {
                    let group = $('.form-group.field-feedback-order_number');
                    group.addClass('has-error');
                    $(".help-block-error", group).html(result.errors.order_number[0]);
                    swal("Ошибка отправки", result.errors.order_number[0], "error");
                }
                return;
            }
            let notice = new Notice(result.status, result.response);
            notice.showNotice();
        };

        let request = new Ajax({
            url: url,
            data: data,
            callback: callback
        })

        request.ajaxRequestDOM();

        return false;
    })
}

function writeCookie(name, val, expires) {
    let date = new Date;
    date.setDate(date.getDate() + expires);
    document.cookie = name + "=" + val + "; domain=.e-kit.pro; path=/; expires=" + date.toUTCString();
}

function readCookie(name) {
    var matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

function close_modal() {
    writeCookie('cargo-info-270722', '1', 3);
    return true;
}

function show_notice_modal() {
    let show = readCookie('cargo-info-270722');
    if (!show) {
        $('#cargo-info').modal('show');
    }
    return show;
}



function bindFileUpload() {
    let input = $('.file input[type="file"]');
    let label = input.closest('.file').find('label');
    $(input).on('change', function () {
        let file_name = $(this)[0].files[0].name;
        label.text(file_name);
    });
}

/**
 * $(e).toggleText('After', 'Before')
 */
$.fn.extend({
    toggleText: function (a, b) {
        return this.text(this.text() == b ? a : b);
    }
});